import(/* webpackMode: "eager" */ "/codebuild/output/src3665595593/src/apps/profile/src/app/error.tsx");
